/**
 * 텍스트 및 컨텐츠 관련 스타일 컴포넌트
 */
import styled from 'styled-components';

export const PageImage = styled.img`
  width: 100%;
  max-width: 800px;
  margin: 0 auto ${props => props.theme.spacing['2xl']};
  display: block;
  border-radius: ${props => props.theme.borderRadius.md};
  box-shadow: ${props => props.theme.shadows.md};
`;

export const Subtitle = styled.h3`
  font-size: ${props => `var(--viewer-font-size, ${props.theme.fontSize.sm})`};
  font-weight: ${props => `var(--viewer-font-weight, ${props.theme.fontWeight.medium})`};
  font-family: ${props => `var(--viewer-font-family, inherit)`};
  letter-spacing: ${props => `var(--viewer-letter-spacing, 0em)`};
  line-height: ${props => `var(--viewer-line-height, 1.5)`};
  color: ${props => props.theme.colors.book.color2b};
  margin-bottom: ${props => props.theme.spacing['2xl']};
  html.dark-mode & {
    color: #EBEBEB;
  }
`;

export const Title = styled.h1`
  font-size: ${props => `calc(var(--viewer-font-size, ${props.theme.fontSize.base}) * 1.25)`};
  font-weight: ${props => `var(--viewer-font-weight, ${props.theme.fontWeight.bold})`};
  font-family: ${props => `var(--viewer-font-family, inherit)`};
  letter-spacing: ${props => `var(--viewer-letter-spacing, 0em)`};
  line-height: ${props => `var(--viewer-line-height, 1.5)`};
  color: ${props => props.theme.colors.book.color2b};
  margin-bottom: ${props => props.theme.spacing.lg};
  html.dark-mode & {
    color: #EBEBEB;
  }
`;


export const ParagraphText = styled.div<{ $fontSize?: number; $fontWeight?: number; $letterSpacing?: number; $lineHeight?: number; $fontFamily?: string }>`
  position: relative;
  overflow: visible;
  font-size: ${props => props.$fontSize ? `${props.$fontSize}px` : `var(--viewer-font-size, ${props.theme.fontSize.sm})`};
  font-weight: ${props => props.$fontWeight ? `${props.$fontWeight}` : `var(--viewer-font-weight, ${props.theme.fontWeight.normal})`};
  line-height: ${props => props.$lineHeight ? `${props.$lineHeight}` : `var(--viewer-line-height, 2)`};
  letter-spacing: ${props => props.$letterSpacing !== undefined ? `${(props.$letterSpacing - 5) * 0.02}em` : `var(--viewer-letter-spacing, 0em)`};
  font-family: ${props => props.$fontFamily && props.$fontFamily !== 'inherit' ? `"${props.$fontFamily}", sans-serif` : `var(--viewer-font-family, inherit)`};
  color: ${props => props.theme.colors.book.color2b};
  margin-bottom: ${props => props.theme.spacing.md};
  &::selection,
  & *::selection {
    background-color: #3390FF;
    color: white;
  }
  html.dark-mode & {
    color: #EBEBEB;
  }
`;

export const TextContentWrapper = styled.span<{ $fontSize?: number; $fontWeight?: number; $letterSpacing?: number; $lineHeight?: number; $fontFamily?: string }>`
  position: relative;
  z-index: 1;
  font-size: ${props => props.$fontSize ? `${props.$fontSize}px` : 'inherit'};
  font-weight: ${props => props.$fontWeight ? `${props.$fontWeight}` : 'inherit'};
  line-height: ${props => props.$lineHeight ? `${props.$lineHeight}` : 'inherit'};
  letter-spacing: ${props => props.$letterSpacing !== undefined ? `${(props.$letterSpacing - 5) * 0.02}em` : 'inherit'};
  font-family: ${props => props.$fontFamily && props.$fontFamily !== 'inherit' ? `"${props.$fontFamily}", sans-serif` : 'inherit'};

  &::selection,
  & *::selection {
    background-color: #3390FF;
    color: white;
  }
  html.dark-mode & {
    color: #EBEBEB;
  }
`;

export const Paragraph = styled.p<{ $fontSize?: number; $fontWeight?: number; $letterSpacing?: number; $lineHeight?: number; $fontFamily?: string }>`
  font-size: ${props => props.$fontSize ? `${props.$fontSize}px` : `var(--viewer-font-size, ${props.theme.fontSize.base})`};
  font-weight: ${props => props.$fontWeight ? `${props.$fontWeight}` : `var(--viewer-font-weight, ${props.theme.fontWeight.normal})`};
  line-height: ${props => props.$lineHeight ? `${props.$lineHeight}` : `var(--viewer-line-height, 1.8)`};
  letter-spacing: ${props => props.$letterSpacing !== undefined ? `${(props.$letterSpacing - 5) * 0.02}em` : `var(--viewer-letter-spacing, 0em)`};
  font-family: ${props => props.$fontFamily && props.$fontFamily !== 'inherit' ? `"${props.$fontFamily}", sans-serif` : `var(--viewer-font-family, inherit)`};
  color: ${props => props.theme.colors.gray[800]};
  margin-bottom: ${props => props.theme.spacing.md};
  white-space: pre-wrap;
`;

export const MarkdownContent = styled.div`
  margin-top: ${props => props.theme.spacing['2xl']};
  padding: ${props => props.theme.spacing.lg};
  background-color: ${props => props.theme.colors.gray[50]};
  border-radius: ${props => props.theme.borderRadius.md};
  border-left: 4px solid ${props => props.theme.colors.primary[500]};
  
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: monospace;
  }
`;

